function sanitize(data) {
  if (data) {
    if (Array.isArray(data)) {
      return data.map((el) => {
        let attributes = el.attributes || {};

        attributes.id = parseInt(el.id);
        const keys = Object.keys(attributes);
        for (let a = 0; a < keys.length; a++) {
          if (attributes[keys[a]] && attributes[keys[a]].data) {
            attributes[keys[a]] = sanitize(attributes[keys[a]].data);
          }
          if (attributes[keys[a]] && attributes[keys[a]].data === null) {
            attributes[keys[a]] = null;
          }
        }

        return attributes;
      });
    } else {
      let attributes = data.attributes || {};

      const keys = Object.keys(attributes);
      for (let a = 0; a < keys.length; a++) {
        if (attributes[keys[a]] && attributes[keys[a]].data) {
          attributes[keys[a]] = sanitize(attributes[keys[a]].data);
        }

        if (attributes[keys[a]] && attributes[keys[a]].data === null) {
          attributes[keys[a]] = null;
        }
      }

      return data.id ? { id: parseInt(data.id), ...attributes } : null;
    }
  }
}

var functions = {
  sanitize,
};

export default functions;
